import { ReactNode } from 'react';
import { Integration } from '../../shared/interfaces/integration';
import { PipelineReviewContent } from './components/PipelineReviewContent';
import { usePipelineReview } from './hooks/usePipelineReview';
import { RetryApiAlert } from '../../shared/components/RetryApiAlert/RetryApiAlert';
import { EntityUIState } from '../../request/interfaces/entity-ui-state';
import { LoadingPageSpinner } from '../../shared/components/LoadingPageSpinner';
import { WizardStepController } from '../../wizard/interfaces/wizard-step-controller';

export interface PipelineReviewProps {
  title: ReactNode;
  subtitle: string;
  pipeline: Integration;
  onStateUpdate: (state: object) => void;
  isEditing?: boolean;
  controller?: WizardStepController;
}

export function PipelineReview({
  pipeline,
  title,
  subtitle,
  onStateUpdate,
  isEditing,
  controller
}: PipelineReviewProps) {
  const { fetchReviewContent, content, uiState, error } = usePipelineReview(
    pipeline.id,
    !!isEditing
  );

  return (
    <>
      {uiState === EntityUIState.LOADING ? (
        <LoadingPageSpinner
          className='h-100'
          title='Fetching review page content'
          subtitle='Hang on while we calculate the objects selection diff. It may take a while based on how many
        objects there are in the Source.'
          showElapsedTime
        />
      ) : null}

      {uiState === EntityUIState.IDLE && content ? (
        <PipelineReviewContent
          title={title}
          pipeline={pipeline}
          onStateUpdate={onStateUpdate}
          isEditing={isEditing}
          subtitle={subtitle}
          content={content}
          controller={controller}
        />
      ) : null}

      {uiState === EntityUIState.ERRORED && error ? (
        <RetryApiAlert
          dataId='pipeline-review'
          className='h-100'
          subTitle={error}
          secondaryCTAProps={{
            children: 'Try Again',
            onClick: fetchReviewContent
          }}
        />
      ) : null}
    </>
  );
}
